import UniqueID from "@tiptap-pro/extension-unique-id";
import { v4 } from "uuid";

export default UniqueID.extend( {
	addOptions() {
		return {
			attributeName: "id",
			types: [
				"teaming-commitment",
				"teaming-topic",
				"teaming-decision",
			],
			generateID: () => v4(),
			filterTransaction: null,
		};
	},
} );
